<template>
  <div class="sun">
    <slot name="content"/>
  </div>
</template>

<script>
export default {
  name: 'Sun',
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';

.sun {
  width: 100%;
  height: 175px;
  display: flex;
  justify-content: center;

  border-radius: 50% / 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  background: $riseup_yellow;
  margin-top: 45px;
}
</style>
